import { z } from "zod";
import { zodDayjs } from "../utils/zodHelpers";

export const TreatmentSaveRequestSchema = z.object({
  drugId: z.string(),
  startDate: zodDayjs,
  indicationId: z.number(),
  endDate: zodDayjs.nullish(),
  treatmentId: z.number().nullish(),
});

export type TreatmentSaveRequest = z.infer<typeof TreatmentSaveRequestSchema>;

export const TreatmentPostRequestSchema = z.object({
  drugId: z.string(),
  startDate: zodDayjs,
  endDate: zodDayjs.nullish(),
  indicationId: z.number(),
});

export type TreatmentPostRequest = z.infer<typeof TreatmentPostRequestSchema>;

export const TreatmentPutRequestSchema = z.object({
  drugId: z.string(),
  startDate: zodDayjs,
  endDate: zodDayjs.nullish(),
  indicationId: z.number(),
});

export type TreatmentPutRequest = z.infer<typeof TreatmentPutRequestSchema>;

export const TreatmentSchema = z.object({
  drugId: z.number(),
  startDate: zodDayjs,
  indicationId: z.number(),
  endDate: zodDayjs.nullish(),
  treatmentId: z.number(),
  patientId: z.number(),
  modifyDateTime: zodDayjs,
});

export type Treatment = z.infer<typeof TreatmentSchema>;

export const TreatmentGetResponseSchema = z.object({
  drugId: z.number(),
  startDate: zodDayjs,
  indicationId: z.number(),
  endDate: zodDayjs.nullish(),
  treatmentId: z.number(),
  patientId: z.number(),
  modifyDateTime: zodDayjs,
});

export type TreatmentGetResponse = z.infer<typeof TreatmentGetResponseSchema>;

export const TreatmentsGetResponseSchema = z.array(TreatmentGetResponseSchema);

export type TreatmentsGetResponse = z.infer<typeof TreatmentsGetResponseSchema>;
